/* eslint-disable camelcase */
import * as yup from 'yup';
import { Schema } from 'yup';

export interface SendingOrderCreate {
  date_id?: number | undefined;
  // Fas A skapar beställningen med enbart kontaktuppgifter + datum. product_id, urval och
  // leveransmetoder fylls i under fas B (redigeringen) och är därför valfria vid skapande.
  product_id?: number | undefined;
  owner_id?: number | undefined;
  // 0 = Pågående, 1 = Inskickad, 2 = Komplettering behövs, 3 = Levererad
  status?: number | undefined;
  color: boolean;
  customer?: string | null | undefined;
  message?: string | undefined;
  createdByName: string;
  createdByEmail: string;
  payDate?: string | undefined;
  deliveryMethodOrder?: string | undefined;
  selectionDescription?: string | undefined;
}

export const SendingOrderCreateSchema: Schema<SendingOrderCreate> = yup.object().shape({
  date_id: yup.number().required('Måste anges').typeError('Måste välja datum'),
  product_id: yup.number().optional(),
  owner_id: yup.number().optional(),
  status: yup.number().optional(),
  color: yup.boolean().required('Måste anges'),
  customer: yup.string().optional(),
  message: yup.string().optional(),
  createdByName: yup.string().required('Måste anges!'),
  createdByEmail: yup.string().email('Ange en giltig e-postadress').required('Måste anges!'),
  payDate: yup.string().optional(),
  deliveryMethodOrder: yup.string().optional(),
  selectionDescription: yup.string().optional(),
});
